// @ts-nocheck
import * as resourcesActions from '../actions/resources.actions';

const initialStore = {
  baseCurrencyCatalog: [],
  businessInsightsSiteViews: [],
  businessUnits: [],
  userPartners: [],
  userRoles: [],
  userTypes: []
};

const actionsMap = {
  [resourcesActions.RESOURCES_SET_BASE_CURRENCY_CATALOG]: (store, action) => {
    const { baseCurrencyCatalog } = action.data;
    return {
      ...store,
      baseCurrencyCatalog
    };
  },
  [resourcesActions.RESOURCES_SET_USER_ROLES]: (store, action) => {
    const { userRoles } = action.data;
    return {
      ...store,
      userRoles
    };
  },
  [resourcesActions.RESOURCES_SET_USER_PARTNERS]: (store, action) => {
    const { userPartners } = action.data;
    return {
      ...store,
      userPartners
    };
  },
  [resourcesActions.RESOURCES_SET_USER_TYPES]: (store, action) => {
    const { userTypes } = action.data;
    return {
      ...store,
      userTypes
    };
  },
  [resourcesActions.RESOURCES_CLEAN]: () => {
    return {
      ...initialStore
    };
  },
  [resourcesActions.RESOURCES_SET_BUSINESS_UNITS]: (store, action) => {
    const { businessUnits } = action.data;
    return {
      ...store,
      businessUnits
    };
  },
  [resourcesActions.RESOURCES_SET_BUSINESS_INSIGHTS_SITE_VIEWS]: (store, action) => {
    const { businessInsightsSiteViews } = action.data;
    return {
      ...store,
      businessInsightsSiteViews
    };
  }
};

export default function reducer(store = initialStore, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(store, action) : store;
}
